import { Controller } from '@hotwired/stimulus';
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
import { fr } from "intl-tel-input/i18n";

export default class extends Controller {
  static targets = ['input'];

  connect () {
    this.instances = [];
    this.initTelInput();
  }

  initTelInput () {
    this.inputTargets.forEach((input) => {
      if (input.parentElement.classList.contains('iti')) { return; }

      this.instances.push(
        intlTelInput(input, {
          initialCountry: 'FR',
          preferredCountries: ['FR'],
          strictMode: true,
          separateDialCode: true,
          formatOnDisplay: true,
          autoHideDialCode: false,
          nationalMode: false,
          i18n: fr,
        })
      );
    });
  }

  setPhoneNumber () {
    this.instances.forEach((instance) => {
      const number = instance.getNumber();

      if (number) {
        instance.telInput.value = number.replace(/\s/g, '');
      }
    });
  }

  inputTargetConnected () {
    if (this.instances === undefined) { return; }
    this.initTelInput();
  }
}
